<template>
  <div class="table-content animate-page">

    <table id="myTable" class="w-full" v-if="data.length !== 0">
      <thead>
        <tr style="background: linear-gradient(135deg,#1e293b,#334155);">
          <th
            class="text-right py-3 pr-4 text-xs font-semibold text-white text-opacity-70 uppercase tracking-wider"
            v-if="num"
          >#</th>
          <th
            v-for="(item, index) in fields"
            :key="index"
            class="text-right py-3 px-3 text-xs font-semibold text-white text-opacity-70 uppercase tracking-wider"
          >{{ item.title }}</th>
          <th
            class="text-right py-3 px-3 text-xs font-semibold text-white text-opacity-70 uppercase tracking-wider"
            v-if="actions"
          >إجراءات</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in data"
          :key="item.id"
          class="border-b border-gray-50 duration-200 text-sm"
          :class="index % 2 === 0 ? 'bg-white' : 'bg-surface'"
          style="transition: background .2s;"
          @mouseenter="$event.currentTarget.style.background='#ecfdf5'"
          @mouseleave="$event.currentTarget.style.background=''"
        >
          <td class="font-medium text-dark-2 pr-4 py-3 border-b border-gray-50" v-if="num">
            <span class="inline-flex items-center justify-center w-6 h-6 rounded-md bg-surface-2 text-xs font-bold text-muted">
              {{ index + 1 }}
            </span>
          </td>
          <template v-for="(field, fi) in fields">
            <td class="text-dark-2 px-3 py-3 border-b border-gray-50" :key="fi">
              <slot :name="field.key" :item="item">
                {{ item[field.key] }}
              </slot>
            </td>
          </template>
          <td v-if="actions" class="px-3 py-3 border-b border-gray-50">
            <slot name="actions" :item="item">
              <span class="text-gray-400 text-xs font-medium">—</span>
            </slot>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Empty state -->
    <div
      class="flex flex-col items-center justify-center py-16 animate-fade-in"
      v-if="!$store.state.loading && data.length === 0"
    >
      <div
        class="w-16 h-16 rounded-2xl flex-center mb-4"
        style="background: linear-gradient(135deg,#ecfdf5,#d1fae5);"
      >
        <i class="far fa-folder-open text-2xl text-main"></i>
      </div>
      <h2 class="font-bold text-dark-2 text-lg mb-1">لا توجد بيانات</h2>
      <p class="text-muted text-sm">لا توجد بيانات متوفرة حالياً</p>
    </div>

  </div>
</template>

<script>
export default {
  emits: ["edit", "acceptMember", "reject", "deletItem", "filters"],
  props: {
    data:    { default: () => [], type: Array },
    fields:  { default: () => [], type: Array },
    num:     { default: true,     type: Boolean },
    actions: { default: true,     type: Boolean },
  },
};
</script>

<style>
#myTable td, #myTable th { padding-left: 0.75rem; padding-right: 0.75rem; }
#myTable .actions-list   { display: flex; align-items: center; gap: 0.375rem; padding-top: 0.25rem; padding-bottom: 0.25rem; }
#myTable .actions-list li {
  width: 2rem; height: 2rem;
  display: flex; align-items: center; justify-content: center;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s;
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  box-shadow: 0 1px 2px rgba(0,0,0,.05);
}
#myTable .actions-list li:hover { transform: translateY(-1px); box-shadow: 0 3px 8px -2px rgba(0,0,0,.12); }
</style>
